import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import { dismissErrors } from 'mx_pcb_assembly/store/slice';

const Alert = () => {
  const dispatch = useDispatch();
  const { errors } = useSelector((state) => state.mx_assembly);
  const handleClose = () => dispatch(dismissErrors());

  let content = null;
  const show = errors && errors.length;
  if (show) {
    content = (
      <ul className="m-0">
        {errors.map((error, index) => <li key={index}>{error}</li>)}
      </ul>
    );
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title>Warning</Modal.Title>
      </Modal.Header>
      <Modal.Body>{content}</Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <button type="button" className="btn btn-primary" onClick={handleClose}>
          ok
        </button>
      </Modal.Footer>
    </Modal>
  )
};

export default Alert;
